import { render, staticRenderFns } from "./EditorPropertyText.vue?vue&type=template&id=735ee630&lang=pug"
import script from "./EditorPropertyText.vue?vue&type=script&lang=js"
export * from "./EditorPropertyText.vue?vue&type=script&lang=js"
import style0 from "./EditorPropertyText.vue?vue&type=style&index=0&id=735ee630&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports